import { render, staticRenderFns } from "./changePermission.vue?vue&type=template&id=5acaf524&scoped=true&"
import script from "./changePermission.vue?vue&type=script&lang=js&"
export * from "./changePermission.vue?vue&type=script&lang=js&"
import style0 from "./changePermission.vue?vue&type=style&index=0&id=5acaf524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acaf524",
  null
  
)

export default component.exports